import React, { useState, useEffect, useContext, useRef } from "react";
import "./Header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Form from "react-bootstrap/Form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-regular-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleLeft,
  faAngleRight,
  fas,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import ScrollToTop from "../ScrollTotop/ScrollTotop";
import Notification from "../Notification/Notification";
import { InputGroup, ListGroup } from "react-bootstrap";
import { AppSetup, Webheader } from "../../utils/apis/common/Common";
import { Context } from "../../utils/context";
import { Category, categoryForWebsite } from "../../utils/apis/Product/Product";
import Cookies from "js-cookie";
library.add(fas);

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [showNotification, setShowNotification] = useState(false);
  const handleCloseNotification = () => setShowNotification(false);
  const handleShowNotification = () => setShowNotification(true);

  const [activeItem, setActiveItem] = useState(() => {
    return localStorage.getItem("activeItem") || "home";
  });

  useEffect(() => {
    const path = location.pathname.substr(1);
    updateActiveItem(path || "home");
  }, [location]);

  const updateActiveItem = (newActiveItem) => {
    localStorage.setItem("activeItem", newActiveItem);
    setActiveItem(newActiveItem);
  };

  const [activeLink, setActiveLink] = useState("home");
  useEffect(() => {
    getSetup();
    getCategory();
    const path = location.pathname.substring(1);
    setActiveLink(path || "home");
  }, [location.pathname]);

  const handleNavItemClick = (id) => {
    navigate(`/select-from-category/${id}`);
    const navbarToggle = document.querySelector(".navbar-toggler");
    if (navbarToggle && window.innerWidth <= 992) {
      navbarToggle.click();
    }
  };

  const navigateToCategory = (id) => {
    navigate(`/select-from-category/${id}`);
  };

  const [searchToggled, setIsToggled] = useState(false);
  const searchRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsToggled(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleClick = () => {
    setIsToggled((prevState) => !prevState);
  };

  const {
    cartCount,
    signin,
    setSignin,
    wishlistData,
    addCartModal,
    getData,
    setSearch,
    search,
  } = useContext(Context);

  const [category, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const getCategory = async () => {
    const res = await categoryForWebsite();
    if (res?.success) {
      setCategory(res.data);
    }
  };

  const [products, setProducts] = useState([]);

  const getProducts = async () => {
    const res = await getData(`/without-login/product?term=${search}`);
    if (res?.success) {
      setProducts(res?.data);
    }
  };

  useEffect(() => {
    getProducts();
  }, [search]);

  const [header, setHeader] = useState([]);

  const { IMG_URL } = useContext(Context);

  const [setups, setSetup] = useState();
  const getSetup = async () => {
    const res = await AppSetup();
    if (res?.success) {
      setSetup(res?.data);
    }
  };

  const handleLogout = () => {
    Cookies.remove("silk_security", { path: "/" });
    Cookies.remove("user_id", { path: "/" });
    Cookies.remove("silk_advertise", { path: "/" });
    setSignin(false);
    navigate("/");
    window.location.reload();
  };

  const handleNavigate = async (product_id) => {
    localStorage.setItem("product_id", product_id);
    window.location.href = `/vendor-page/${product_id}`;
    setIsToggled(false);
  };

  const categories = [
    {
      name: "Men Suits",
      subcategories: ["Blazer", "Tuxedo", "Formal Suit"],
    },
    {
      name: "Women Dresses",
      subcategories: ["Evening Gown", "Cocktail Dress", "Casual Dress"],
    },
    {
      name: "Footwear",
      subcategories: ["Sneakers", "Formal Shoes", "Sandals"],
    },
  ];

  const [showMobileSubcategory, setShowMobileSubcategory] = useState(false);

  const headerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If click is outside header area
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setIsToggled(false);
        setProducts([]); // close suggestion list
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <ScrollToTop />
      <section
        className="second-header-sec"
        style={{
          backgroundColor: setups?.header_color,
        }}
        ref={headerRef}>
        <div className="container-fluid ">
          <div className="row">
            <div className="col-xl-11 mx-auto">
              <Navbar expand="lg">
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Brand as={Link} to="/">
                  <img
                    className="headlogo"
                    // src={process.env.PUBLIC_URL + "/assets/Image/Logo/logo2.png"}
                    src={IMG_URL + setups?.image}
                    alt="Logo"
                  />
                </Navbar.Brand>

                <Link className="all-icon mobaddcarticon" to={"/product-cart"}>
                  <FontAwesomeIcon
                    icon="fa-solid fa-cart-shopping"
                    className="cart-logo"
                  />
                  <span className="cart-item-count-text position-absolute top start translate-middle bg-danger1 border border-light rounded-circle">
                    {cartCount}
                  </span>
                </Link>

                <Navbar.Collapse id="basic-navbar-nav">
                  {!showMobileSubcategory ? (
                    <>
                      {header?.length > 0 ? (
                        <Nav className="mx-auto">
                          {header?.map((item, index) =>
                            item?.id === 7 ? (
                              <NavDropdown
                                title=" Category"
                                id="basic-nav-dropdown"
                                className="me-3"
                                key={index}>
                                {category?.map((value) => (
                                  <NavDropdown.Item
                                    key={value?.id}
                                    onClick={() =>
                                      navigateToCategory(value?.id)
                                    }>
                                    {value.name}
                                  </NavDropdown.Item>
                                ))}
                              </NavDropdown>
                            ) : (
                              <Nav.Link key={index}>{item.name}</Nav.Link>
                            )
                          )}
                        </Nav>
                      ) : (
                        <div className="header_holder">
                          <Nav className="mx-auto">
                            <Nav.Link
                              as={Link}
                              to="/"
                              active={activeItem === "home"}
                              onClick={handleNavItemClick}>
                              Home
                            </Nav.Link>

                            <Nav.Link
                              as={Link}
                              to="/about-us"
                              active={activeItem === "about-us"}
                              onClick={handleNavItemClick}>
                              About Us
                            </Nav.Link>

                            {/* <Nav.Link
                              as={Link}
                              to="/sale-products"
                              active={activeItem === "sale-products"}
                              onClick={handleNavItemClick}>
                              Sale
                            </Nav.Link> */}

                            <Nav.Link
                              as={Link}
                              to="/all-products"
                              active={activeItem === "all-products"}
                              onClick={handleNavItemClick}>
                              All Products
                            </Nav.Link>

                            <NavDropdown
                              title="Categories"
                              id="basic-nav-dropdown"
                              className="me-3 custom_dropdwon">
                              <div className="main_category_div">
                                <div className="row">
                                  {category.map((category, index) => (
                                    <div
                                      className="col-lg-3 col-6 pe-0"
                                      key={index}>
                                      <div className="tooltip_column">
                                        <div className="category-section">
                                          <p className="heading_text">
                                            {category.name}
                                          </p>
                                          {category.sub_categories.map(
                                            (sub, subIndex) => (
                                              <NavDropdown.Item
                                                key={subIndex}
                                                className="subcategory_text"
                                                onClick={() =>
                                                  handleNavItemClick(sub?.id)
                                                }>
                                                {sub?.name}
                                              </NavDropdown.Item>
                                            )
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </NavDropdown>

                            {/* <div className="mobile_category_holder">
                              {category?.map((item) => (
                                <Nav className="mx-auto" key={item?.id}>
                                  <Nav.Link
                                    as={Link}
                                    active={activeItem === "home"}>
                                    <div
                                      className="category_name_holder"
                                      onClick={() => {
                                        setSelectedCategory(item);
                                        setShowMobileSubcategory(true);
                                      }}>
                                      <p className="category_name">
                                        {item?.name}
                                      </p>
                                      <div className="icon_holder">
                                        <FontAwesomeIcon
                                          icon={faAngleRight}
                                          className="icon"
                                        />
                                      </div>
                                    </div>
                                  </Nav.Link>
                                </Nav>
                              ))}
                            </div> */}
                          </Nav>
                        </div>
                      )}

                      <div className="all-icon mt-lg-0 mt-md-3 mt-sm-3 mt-3 row">
                        <div className="col-lg-7 searchbar-holder-main desksearchhed_searchbar-holder">
                          <InputGroup>
                            <Form.Control
                              type="text"
                              placeholder="Search Product..."
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  navigate(
                                    `/all-products?search=${encodeURIComponent(
                                      search
                                    )}`
                                  );
                                  setProducts([]);
                                  setSearch("");
                                }
                              }}
                            />
                            <InputGroup.Text>
                              <FontAwesomeIcon
                                icon={faSearch}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  navigate(
                                    `/all-products?search=${encodeURIComponent(
                                      search
                                    )}`
                                  );
                                  setProducts([]);
                                  setSearch("");
                                }}
                              />
                            </InputGroup.Text>
                          </InputGroup>
                          {search && (
                            <ListGroup>
                              {products.map((product) => (
                                <ListGroup.Item
                                  key={product?.value}
                                  onClick={() => {
                                    handleNavigate(product?.value);
                                    setProducts([]);
                                    setSearch("");
                                  }}>
                                  {product?.label}
                                </ListGroup.Item>
                              ))}
                            </ListGroup>
                          )}
                        </div>

                        <div className="col-lg-5  d-flex header-icon-holder">
                          {signin ? (
                            <Link to={"/wallet"}></Link>
                          ) : (
                            <Link to={"/login"}></Link>
                          )}

                          {/* <FontAwesomeIcon
                        onClick={handleShowNotification}
                        icon="fa-solid fa-bell"
                        className="cart-logo"
                      /> */}

                          <Link
                            to={"/product-cart"}
                            className="deskaddcarticon">
                            <FontAwesomeIcon
                              icon="fa-solid fa-cart-shopping"
                              className="cart-logo"
                              onClick={handleNavItemClick}
                            />
                            <span className="cart-item-count-text position-absolute top start translate-middle bg-danger1 border border-light rounded-circle">
                              {cartCount}
                            </span>
                          </Link>

                          {signin ? (
                            <>
                              {wishlistData?.length > 0 ? (
                                <Link to={"/wishlist"}>
                                  <FontAwesomeIcon
                                    icon={faHeart}
                                    className="cart-logo"
                                    onClick={handleNavItemClick}
                                  />
                                  <span className="cart-item-count-text position-absolute top start translate-middle bg-danger1 border border-light rounded-circle">
                                    {wishlistData?.length}
                                  </span>
                                </Link>
                              ) : (
                                <Link to={"/empty-wislist"}>
                                  <FontAwesomeIcon
                                    icon={faHeart}
                                    className="cart-logo"
                                    onClick={handleNavItemClick}
                                  />
                                </Link>
                              )}

                              <Link to={"/information"}>
                                <FontAwesomeIcon
                                  icon="fa-solid fa-user"
                                  className="cart-logo"
                                  onClick={handleNavItemClick}
                                />
                              </Link>
                              <Link className="login" onClick={handleLogout}>
                                Logout
                              </Link>
                            </>
                          ) : (
                            <>
                              <Link to={"/empty-wislist"}>
                                <FontAwesomeIcon
                                  icon={faHeart}
                                  className="cart-logo"
                                  onClick={handleNavItemClick}
                                />
                              </Link>
                              <Link to={"/login"} className=" login">
                                Login
                              </Link>
                            </>
                          )}
                        </div>

                        {searchToggled && (
                          <div ref={searchRef} className="input-group-box mb-3">
                            <Form.Control
                              value={search}
                              onChange={(e) => {
                                setSearch(e.target.value);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  navigate(
                                    `/all-products?search=${encodeURIComponent(
                                      search
                                    )}`
                                  );
                                }
                              }}
                              type="search"
                              placeholder="Search Product..."
                            />
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    <div className="mobile_subcategory_holder">
                      <Nav className="mx-auto">
                        <Nav.Link
                          as={Link}
                          className="selected_categry"
                          to="/"
                          active={activeItem === "home"}
                          onClick={() => setShowMobileSubcategory(false)}>
                          <FontAwesomeIcon
                            icon={faAngleLeft}
                            className="back_icon"
                          />{" "}
                          {selectedCategory?.name}
                        </Nav.Link>
                      </Nav>

                      <div className="subcategory_div">
                        {selectedCategory?.sub_categories?.map((sub, index) => (
                          <Nav className="mx-auto" key={index}>
                            <Nav.Link
                              as={Link}
                              to={`/select-from-category/${sub?.id}`}
                              active={activeItem === "home"}
                              onClick={() => handleNavItemClick(sub?.id)}>
                              {sub?.name}
                            </Nav.Link>
                          </Nav>
                        ))}
                      </div>
                    </div>
                  )}
                </Navbar.Collapse>
              </Navbar>

              <div className="mobsearchhed">
                <div className="row">
                  <div className="col-12 searchbar-holder-main searchinpuuhead-mob">
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Search Product..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            navigate(
                              `/all-products?search=${encodeURIComponent(
                                search
                              )}`
                            );
                            setProducts([]);
                            setSearch("");
                          }
                        }}
                      />
                      <InputGroup.Text>
                        <FontAwesomeIcon
                          icon={faSearch}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigate(`/all-products?search=${search}`);
                            setProducts([]);
                            setSearch("");
                          }}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                    {search && (
                      <ListGroup>
                        {products.map((product) => (
                          <ListGroup.Item
                            key={product?.value}
                            onClick={() => {
                              handleNavigate(product?.value);
                              setProducts([]);
                              setSearch("");
                            }}>
                            {product?.label}
                          </ListGroup.Item>
                        ))}
                      </ListGroup>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Notification
        show={showNotification}
        handleClose={handleCloseNotification}
      />
    </>
  );
};

export default Header;
